import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "./api";

export const MEALS = { cafe: "Café", almoco: "Almoço", lanche: "Lanche", jantar: "Jantar" };
export const SHIFTS = { manha: "Manhã", tarde: "Tarde", noite: "Noite", integral: "Integral" };
export const DOC_TYPES = {
  mapa_anterior: { n: 1, label: "Mapa do mês anterior / estoque inicial", short: "Mapa anterior" },
  cardapio: { n: 2, label: "Cardápio SEEDUC do mês vigente", short: "Cardápio SEEDUC" },
  nf_principal: { n: 3, label: "Notas fiscais do fornecedor principal", short: "NF fornecedor" },
  contrato_af: { n: 4, label: "Contrato da agricultura familiar", short: "Contrato AF" },
  nf_af: { n: 5, label: "Notas fiscais da agricultura familiar", short: "NF agricultura" },
  ficha_tecnica: { n: 6, label: "Fichas técnicas, per capita e substituições", short: "Fichas técnicas" },
};
export const DOC_STATUS = {
  extraindo: ["Lendo documento…", "info"],
  extraido: ["Aguardando conferência", "amber"],
  erro: ["Erro na leitura", "red"],
  duplicado: ["Duplicado — bloqueado", "red"],
  confirmado: ["Confirmado", "green"],
  descartado: ["Descartado", "muted"],
};
export const WD = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

export const fmt = (n) => (n == null || n === "" ? "" : Number(n).toLocaleString("pt-BR", { maximumFractionDigits: 3 }));
export const fdate = (s) => (s && s.length >= 10 ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : s || "");
export const fmonth = (m) => (m ? new Date(`${m}-15T12:00:00`).toLocaleDateString("pt-BR", { month: "long", year: "numeric" }) : "");
export const money = (n) => (n == null ? "" : Number(n).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
export const thisMonth = () => new Date().toISOString().slice(0, 7);
export const weekday = (s) => WD[new Date(`${s}T12:00:00`).getDay()];

export function shiftMonth(m, d) {
  const [y, mo] = m.split("-").map(Number);
  const dt = new Date(y, mo - 1 + d, 1);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}`;
}

export function useLoad(fn, deps) {
  const [data, setData] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const reload = useCallback(async () => {
    try {
      setData(await fn());
    } catch (e) {
      toast.error(errMsg(e));
    }
  }, deps);
  useEffect(() => {
    reload();
  }, [reload]);
  return [data, reload, setData];
}

export async function run(fn, ok) {
  try {
    const r = await fn();
    if (ok) toast.success(ok);
    return r ?? true;
  } catch (e) {
    toast.error(errMsg(e), { duration: 8000 });
    return null;
  }
}

export const num = (v) => (v === "" || v == null ? null : Number(String(v).replace(",", ".")));
